import * as React from 'react';

import { IDocument, IEditorState, IPage, ISpread, IDivider } from '../../../../infrastructure/interfaces';
import { PageType } from '../../../../infrastructure/PageType';
import { productType } from '../../../../infrastructure/ProductType';
import BackLayout from '../CropPageView/common/BackLayout';
import FrontLayout from '../CropPageView/common/FrontLayout';
import ResultPage from '../CropPageView/common/PageResult';
import {stringIdentifierForLayoutType} from '../../../../infrastructure/LayoutTypes';
import CatalogContainer from '../CropPageView/Catalog/CatalogContainer';
import BulletinContainer from '../CropPageView/Bulletin/BulletinContainer';
import PostcardContainer from '../CropPageView/Postcard/PostcardContainer';
import PosterContainer from '../CropPageView/Poster/PosterContainer';

export interface IResultContentProps {
  document: IDocument;
  selectedSpread: ISpread | null;
  selectedPage: IPage | null;
  isSpreadView: boolean;
  isEditorEditing: boolean;
  isWebPageCover: boolean;
  disclaimers: any[];
  editor?: IEditorState;
  dividers: IDivider[];
  isPrintDownload: boolean;
}
export default class ResultContentView extends React.Component<IResultContentProps> {

  renderPage(page: IPage, isBrochure: boolean) {
    let layout: string;
    if(isBrochure) {
      layout = '';
    } else {
      layout = stringIdentifierForLayoutType(page.layout);
    }
    return (page.placeholders.map((m, i) => {
      const index = i;
      return (
        <ResultPage
          lastDroppedItem={m}
          index={index}
          key={index}
          document={this.props.document}
          pagePosition={page.position}
          pageNumber={page.number}
          layout={layout}
          isAside={false}
        />);
    }));
  }

  renderFront = () => {
    switch (this.props.document.type) {
      case productType.Brochure:
      case productType.Catalog:
        {
          return (
            <FrontLayout
              document={this.props.document}
              isSpreadView={this.props.isSpreadView}
              mainView={true}
              isEditorRendering={false}
              isWebPageCover={this.props.isWebPageCover}
            />
          );
        }
      case productType.Bulletin:
      default:
        return (
          <div></div>
        );
    }
  }

  renderBack = () => {
    switch (this.props.document.type) {
      case productType.Brochure:
      case productType.Catalog:
        {
          return (
            <BackLayout
              document={this.props.document}
              brandings={this.props.document.brandings}
              isEditorRendering={this.props.isEditorEditing}
              isWebPageCover={this.props.isWebPageCover}
              disclaimers={this.props.disclaimers}
            />
          );
        }
      default:
        return (
          <div></div>
        );
    }
  }

  renderSpread(spread: ISpread) {
    if (spread === null) {
      return null;
    }
    switch (this.props.document.type) {
      case productType.Brochure:
        {
          if (spread.right) {
            if (spread.left.type === PageType.Page && spread.right.type === PageType.Page) {
              return (
                <div className="brochure-product-page-wrapper">
                  <div className={`crop-cont`}>
                    {this.renderPage(spread.left, true)}
                    {this.renderPage(spread.right, true)}
                  </div>
                </div>
              );
            }
          } else {
            if (spread.left.type === PageType.Page) {
              return (
                <div className="brochure-product-page-wrapper">
                  <div className={`crop-cont`}>
                    {this.renderPage(spread.left, true)}
                  </div>
                </div>
              );
            }
          }
          if (spread.left.type === PageType.Back && ((spread.right != null) && (spread.right.type === PageType.Front))) {
            return (
              <div className={`crop-cont crop-cont--cover`}>
                {this.renderBack()}
                {this.renderFront()}
              </div>
            );
          }
        }
      case productType.Catalog:
        {
          if (spread.right) {
            if (spread.left.type === PageType.Page && ((spread.right != null) && (spread.right.type === PageType.Page))) {
              return (
                <CatalogContainer
                  handleDrop={() => {}}
                  removeProduct={() => {}}
                  moveCrop={() => {}}
                  isSpreadView={this.props.isSpreadView}
                  spreadToRender={spread}
                  disclaimers={this.props.disclaimers}
                  document={this.props.document ? this.props.document : null}
                  isEditorRendering={false}
                />
              );
            }
          } else {
            if (spread.left.type === PageType.Page) {
              return (
                <CatalogContainer
                  handleDrop={() => {}}
                  removeProduct={() => {}}
                  moveCrop={() => {}}
                  isSpreadView={this.props.isSpreadView}
                  spreadToRender={spread}
                  disclaimers={this.props.disclaimers}
                  document={this.props.document ? this.props.document : null}
                  isEditorRendering={false}
                />
              );
            }
          }
          if (spread.left.type === PageType.Back && ((spread.right != null) && (spread.right.type === PageType.Front))) {
            return (
              <div className={`crop-cont crop-cont--cover`}>
                {this.renderBack()}
                {this.renderFront()}
              </div>
            );
          }
        }
      case productType.Bulletin:
        {
          return (
            <BulletinContainer
              handleDrop={() => {}}
              removeProduct={() => {}}
              moveCrop={() => {}}
              document={this.props.document ? this.props.document : null}
              isEditorRendering={false}
              disclaimers={this.props.disclaimers}
              brandings={this.props.document.brandings}
              page={spread.left}
            />
          );
        }
      case productType.Postcard:
        {
          return (
            <PostcardContainer
              handleDrop={() => {}}
              removeProduct={() => {}}
              moveCrop={() => {}}
              document={this.props.document ? this.props.document : null}
              spread={spread}
              disclaimers={this.props.disclaimers}
              isPDFRender={true}
            />
          )
        }
      case productType.Poster:
        {
          return (
            <PosterContainer
              handleDrop={() => {}}
              removeProduct={() => {}}
              moveCrop={() => {}}
              document={this.props.document ? this.props.document : null}
              spread={spread}
              disclaimers={this.props.disclaimers}
              isPDFRender={true}
            />
          )
        }
      default:
        return (
          <div></div>
        );
    }
  }

  renderSingle(selectedPage: IPage) {
    switch (this.props.document.type) {
      case productType.Brochure:
        {
          switch (selectedPage.type) {
            case PageType.Page:
              return (
                <div className="brochure-product-page-wrapper">
                  <div className="crop-header">
                  </div>
                  <div className={`crop-cont`}>
                    {this.renderPage(selectedPage, true)}
                  </div>
                  <div className="crop-footer"></div>
                </div>);
            case PageType.Front:
              return (
                <div className={`crop-cont crop-cont--cover`}>
                  {this.renderFront()}
                </div>
              );
            case PageType.Back:
              return (
                <div className={`crop-cont crop-cont--cover`}>
                  {this.renderBack()}
                </div>
              );
          }
        }
      case productType.Catalog:
        {
          switch (selectedPage.type) {
            case PageType.Page:
              return (
                <CatalogContainer
                  handleDrop={() => {}}
                  removeProduct={() => {}}
                  moveCrop={() => {}}
                  isSpreadView={this.props.isSpreadView}
                  pageToRender={selectedPage}
                  disclaimers={this.props.disclaimers}
                  document={this.props.document ? this.props.document : null}
                  isEditorRendering={false}
                />
                );
            case PageType.Front:
              return (
                <div className={`crop-cont crop-cont--cover`}>
                  {this.renderFront()}
                </div>
              );
            case PageType.Back:
              return (
                <div className={`crop-cont crop-cont--cover`}>
                  {this.renderBack()}
                </div>
              );
          }
        }
      case productType.Bulletin:
        {
          return (
            <BulletinContainer
              handleDrop={() => {}}
              removeProduct={() => {}}
              moveCrop={() => {}}
              document={this.props.document ? this.props.document : null}
              isEditorRendering={false}
              disclaimers={this.props.disclaimers}
              brandings={this.props.document.brandings}
              page={selectedPage}
            />
          );
        }
      default:
        return (
          <div></div>
        );
    }

  }

  renderPlaceholders(selectedPage: IPage | null, selectedSpread: ISpread | null) {
    if (this.props.isSpreadView) {
      return this.renderSpread(selectedSpread!);
    }
    return this.renderSingle(selectedPage!);
  }

  renderCropMarks() {
    return(
      <div>
        <div className="crop-page-arrow top left"></div>
        <div className="crop-page-arrow top right"></div>
        <div className="crop-page-arrow bottom left"></div>
        <div className="crop-page-arrow bottom right"></div>
      </div>
    )
  }

  render() {
    const position = (this.props.selectedPage != null) ? this.props.selectedPage.position : 0;
    const right = (this.props.selectedSpread != null) ? this.props.selectedSpread.right : true;
    const classNameBox = !this.props.isSpreadView ? `isSingle ${position}` : '';
    const marginSize = this.props.isPrintDownload ? '0.25rem' : '0';
    const isPrintDownload = this.props.isPrintDownload;
    const printDownloadClassname = isPrintDownload ? 'print-download' : '';
    const zoomNumber: number = (this.props.editor != null) ? this.props.editor.zoomLevel : 100;
    const zoomString = zoomNumber.toString() + '%';
    const isHalfWidth = this.props.isSpreadView && !right && (this.props.document.type != productType.Poster); 
    let outerStyles: React.CSSProperties = {
    };
    let styles: React.CSSProperties = {
      margin: marginSize,
      zoom: zoomString
    };
    return (
      <div className={`crop-page-box result-crop-page-box ${classNameBox} ${this.props.document.type} ${printDownloadClassname}`}
        style={outerStyles}
        >
        {isHalfWidth ? (<div className='half-width'>
          <div className={`crop-page-view ${isHalfWidth ? ' half-width' : ''}`}
            style={styles}
            >
            {this.renderPlaceholders(this.props.selectedPage, this.props.selectedSpread)}
            { isPrintDownload ? this.renderCropMarks() : null }
          </div></div>) : (
            <div className={`crop-page-view ${isHalfWidth ? ' half-width' : ''}`}
              style={styles}
              >
              {this.renderPlaceholders(this.props.selectedPage, this.props.selectedSpread)}
              { isPrintDownload ? this.renderCropMarks() : null }
            </div>
          )
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Result/ResultContent.tsx